<template>
  <div class="max-w-screen-md mx-auto px-4">
    <AnimatedElement>
      <h2 class="text-center text-4xl mb-24">Bouguets</h2>
    </AnimatedElement>
    <div v-if="loading">
      <FlowerIcon name="flower" class="w-12 h-12 animate-spin mx-auto" />
    </div>
    <div v-else class="grid grid-cols-2 gap-x-6 lg:gap-x-12 gap-y-20">
      <AnimatedElement
       v-for="post in posts" :key="post.id"
       class="flex flex-col"
      >
        <img 
          class="aspect-square object-cover max-w-auto w-100 h-100 rounded-lg" 
          :src="post.image"
          loading="lazy"
        />
        <h2 class="text-2xl text-center mt-4 mb-2">{{ post.title }}</h2>
        <div class="text-center mb-4" v-html="post.excerpt"></div>
        <button 
          @click="cartStore.addToCart({
            id: post.id,
            name: post.title,
            image: post.image,
            quantity: 1
          })"
          class="bg-rose-600 rounded-full text-white px-4 py-2 mt-auto self-center"
          >
          Add to cart
        </button>
      </AnimatedElement>
    </div>
  </div>
</template>
  
<script>
import axios from "axios";
import AnimatedElement from "./AnimatedElement.vue";
import FlowerIcon from "./FlowerIcon.vue";
import { useCartStore } from "@/stores/cart";

export default {
  components: {
    AnimatedElement,
    FlowerIcon,
  },
  data() {
    return {
      posts: [],
      loading: true,
      cartStore: useCartStore(),
    };
  },
  mounted() {
    axios
    .get(process.env.VUE_APP_CMS_API_URL + 'products?_embed')
    .then((response) => {
      this.posts = response.data.map((post) => (
        {
          id: post.id,
          title: post.title.rendered,
          excerpt: post.excerpt.rendered,
          image: post._embedded?.["wp:featuredmedia"]?.[0]?.source_url || "",
        }
      ));
      
      const imagePromises = this.posts.map((post) => {
        return new Promise((resolve) => {
          if (post.image) {
            const img = new Image();
            img.src = post.image;
            img.onload = resolve;
            img.onerror = resolve; // Resolve even if the image fails to load
          } else {
            resolve(); // No image to load
          }
        });
      });

      Promise.all(imagePromises)
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error loading images:", error);
          this.loading = false; // Fail-safe
        });
    })
    .catch((error) => {
      console.error("Error fetching posts:", error);
      this.loading = false;
    });
  },
};

</script>
